export default __webpack_public_path__ + "static/media/calender_eduact_logo.451dc5b2.svg";